// CheckPhotosPermission.jsx
import React, { Suspense } from "react";
import { userAccessType } from "utils/lookUpTable";
import CheckPermissionWrapper from "components/CheckPermissionWrapper";
import Photos from ".";
import { useSearchParams } from "react-router-dom";

// Option A: direct import

// Option B (recommended for large bundles): lazy load
// const Photos = React.lazy(() => import("./Photos"));

const CheckPhotosPermission = (props) => {
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const folderId = searchParams.get("folderId");

  return (
    <CheckPermissionWrapper>
      {({ permission }) =>
        permission >= userAccessType.read ? (
          <Photos folderId={folderId} permission={permission} />
        ) : null
      }
    </CheckPermissionWrapper>
  );
};

export default CheckPhotosPermission;
